(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  const wrap=document.getElementById('custom-reviews');if(!wrap)return;
  const more=document.getElementById('cr-more');
  if(more)more.addEventListener('click',()=>{wrap.querySelectorAll('.cr-item--hidden').forEach(el=>el.classList.remove('cr-item--hidden'));more.remove();});
  const lb=document.getElementById('cr-lightbox');
  if(lb){wrap.querySelectorAll('.cr-tile').forEach(t=>t.addEventListener('click',()=>{
    lb.querySelector('img').src=t.dataset.img;
    lb.querySelector('.cr-lb-meta').textContent='★'.repeat(+t.dataset.rating)+' '+t.dataset.author+' – '+t.dataset.text;
    lb.showModal();}));
    lb.querySelector('.cr-lb-close').addEventListener('click',()=>lb.close());}
  const btn=document.getElementById('cr-open-form'),form=document.getElementById('cr-form');
  if(btn&&form){btn.addEventListener('click',()=>{form.hidden=!form.hidden;});
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const msg=document.getElementById('cr-msg');
      const files=form.querySelector('input[type=file]').files;
      if(files.length>3){msg.textContent='Bitte maximal 3 Fotos.';return;}
      for(const f of files){if(f.size>5*1024*1024){msg.textContent='Ein Foto ist größer als 5 MB.';return;}}
      msg.textContent='Wird gesendet …';
      try{
        const res=await fetch(wrap.dataset.workerUrl,{method:'POST',body:new FormData(form)});
        if(!res.ok)throw new Error(await res.text());
        form.reset();form.hidden=true;
        msg.textContent='';btn.textContent='Danke! Deine Bewertung wird nach Prüfung veröffentlicht. ✓';btn.disabled=true;
      }catch(err){msg.textContent='Fehler beim Senden – bitte später erneut versuchen.';}
    });}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('.content-ul-tab [data-id^="js-more-info-documents-"]');
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      trigger.click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ul-atelier-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeAtelier(root) {
    if (root.dataset.ulReady) return;
    root.dataset.ulReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 750px)');
    if (reduced.matches || !desktop.matches || !('IntersectionObserver' in window)) return;
    const pending = Array.from(root.querySelectorAll('[data-ul-reveal]')).filter(el => el.getBoundingClientRect().top > window.innerHeight);
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {if (entry.isIntersecting) {entry.target.classList.remove('ul-is-pending');observer.unobserve(entry.target);}}), {threshold:0.08});
    pending.forEach(el => {el.classList.add('ul-is-pending');observer.observe(el);});
    window.setTimeout(() => pending.forEach(el => el.classList.remove('ul-is-pending')), 12000);

  }
  document.querySelectorAll('[data-ul-atelier]').forEach(initializeAtelier);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ul-atelier]').forEach(initializeAtelier));
})();

  } catch(e) { console.error(e); }
})();
})();
